export default "__VITE_ASSET__CR_9jLhs__"